import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUser } from "../../helpers/user";
import listUsersFilters, { listUsers, listUsersByLoja } from "./services";

interface IStateListUsuarios {
  status: "" | "success" | "failed" | "loading";
  statusUserByLoja: "" | "success" | "failed" | "loading";
  data: any[];
  dataUserByLoja: any[];
  feedbackError: string;
  feedbackErrorUserByLoja: string;
}

export const actionListUsuarios = createAsyncThunk(
  "USUARIOS/LIST_WITH_FILTERS",
  async (params: any, { getState }) => {
    const {
      getLojas: { lojaSelected },
      getRegionais: { regionalSelected },
    }: any = getState();
    const { usuario } = getUser();

    const request = await listUsersFilters({
      idLoja: lojaSelected,
      idRegional: regionalSelected,
      nivel: usuario.nivel,
      onlyAdm: params?.onlyAdm,
    });
    return request;
  },
);

export const actionListUsers = createAsyncThunk(
  "USUARIOS/LIST_ALL",
  async () => {
    const response = await listUsers();
    return response;
  },
);

export const actionListUsersByLoja = createAsyncThunk(
  "USUARIOS/LIST_BY_LOJA",
  async ({ idLoja }: any) => {
    const request = await listUsersByLoja({ idLoja });
    return request;
  },
);

const listUsuariosSlice = createSlice({
  name: "listUsuarios",
  initialState: <IStateListUsuarios>{
    status: "",
    statusUserByLoja: "",
    data: [],
    dataUserByLoja: [],
    feedbackError: "",
    feedbackErrorUserByLoja: "",
  },
  reducers: {
    actionReset: (state) => {
      state.status = "";
      state.feedbackError = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(actionListUsuarios.pending, (state) => {
      state.status = "loading";
    });
    builder.addCase(actionListUsuarios.fulfilled, (state, { payload }) => {
      state.status = "success";
      state.data = payload;
    });
    builder.addCase(actionListUsuarios.rejected, (state, action) => {
      state.status = "failed";
      state.feedbackError = action.error.message || "Erro ao carregar usuários";
    });

    builder.addCase(actionListUsers.pending, (state) => {
      state.status = "loading";
    });
    builder.addCase(actionListUsers.fulfilled, (state, { payload }) => {
      state.status = "success";
      state.data = payload;
    });
    builder.addCase(actionListUsers.rejected, (state, action) => {
      state.status = "failed";
      state.feedbackError =
        action.error.message || "Erro ao listar todos os usuários";
    });
  },
});

export const { actionReset } = listUsuariosSlice.actions;
export default listUsuariosSlice.reducer;
